import { InferType, object } from 'yup';
import { Nullable } from '../../../model/common';
import { PriceSchemaParams, QuantitySchemaParams, priceSchema, quantitySchema, safeString } from './common';

interface LuceraAmendOrderSchemaParams extends PriceSchemaParams, QuantitySchemaParams {}

export const luceraAmendOrderSchema = (params: LuceraAmendOrderSchemaParams) => {
    return object({
        pair: safeString(),
        side: safeString(),
        ccy: safeString(),
        orderType: safeString(),
        orderId: safeString(),
        status: safeString(),
        duration: safeString(),
        quantity: quantitySchema(params),
        price: priceSchema(params)
    });
};

export type LuceraAmendOrderFormValues = InferType<ReturnType<typeof luceraAmendOrderSchema>>;
export type LuceraAmendOrderFormInput = Nullable<LuceraAmendOrderFormValues>;
